<script type="ts">
  import {createEventDispatcher} from 'svelte';
  import {LG$} from '@px/streams/lang';
  import Modal from '@px/widgets-pc/Modal.svelte';
  import Button from '@px/widgets/Button.svelte';
  import {clang} from '@px/languages/common.lang';

  export let title = '';
  export let message = '';

  const dispatch = createEventDispatcher();

  function handleCloseClick() {
    dispatch('close');
  }
</script>

<style>
  .footer {
    margin: 40px auto 0;
  }
</style>

<Modal style="padding: 24px; border-radius: 12px; width: 500px; background: var(--B2); border: 1px solid var(--B0)">
  <div slot="header" class="df aic jcsb lh24 T1">
    <span class="f16">{title}</span>
  </div>
  <div class="body mt20 T1">{message}</div>
  <div slot="footer" class="footer df jcfe tr mt24">
    <Button class="btn BLUE" on:click={handleCloseClick} type="primary">{$LG$(clang.OK)}</Button>
  </div>
</Modal>
